import {useEffect, useState} from "react"

import {
  HOST_EVENTS,
  LEGACY_HOST_EVENTS,
  LEGACY_PAGE_CONTEXT_EVENT,
  PAGE_CONTEXT_EVENT,
  addHostEventListener,
  getHostBridge,
} from "@frontend/hostContract"

export {
  PAGE_CONTEXT_EVENT,
  LEGACY_PAGE_CONTEXT_EVENT,
  HOST_EVENTS,
  LEGACY_HOST_EVENTS,
}

/**
 * Reactively tracks the page context set by the host page.
 *
 * Reads the initial value from the normalized host bridge and listens for
 * subsequent updates via the preferred and legacy CustomEvent names.
 */
export const usePageContext = (): Ri2PageContext | null => {
  const [context, setContext] = useState<Ri2PageContext | null>(
    () => getHostBridge()?.pageContext ?? null,
  )

  useEffect(() => {
    const handler = (e: Event): void => {
      const detail = (e as CustomEvent<Ri2PageContext | null>).detail
      setContext(detail ?? null)
    }

    return addHostEventListener("pageContext", handler)
  }, [])

  return context
}
